import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class ProductReportAPI {
  URI_V1 = "/v1/product-reports";

  getCompanyId = () => companyAPI.getCompanyManagment().id;

  getSummary = async () => {
    return await apiService.get(
      `${this.URI_V1}/summary?companyId=${this.getCompanyId()}`
    );
  };

}